import { LazyDataSourceApiResponse } from '@epam/uui';
import { Industry } from '../../../../project-list/components/project-card/modal';
import ProjectListService from '../../../../../services/api/project-list/projectListService';

export default async function (
  request: any
): Promise<LazyDataSourceApiResponse<Industry>> {
  let res: Array<Industry>;
  /*
    if search input is empty (e.g. EU opened dropdown of PickerInput comp and didn't type anything)
    search for 'A' to get skills to be rendered in the dropdown list
    */
  const query = request.search.length ? request.search : '';
  const response = await ProjectListService.getIndustries(query);
  // eslint-disable-next-line prefer-const
  res = response.industries;

  const formattedResult = res
    .filter((item) => item.externalId !== '-1')
    .map((item) => {
      return {
        externalId: item.externalId,
        id: item.id,
        name: item.name,
        available: item.available,
      };
    });
  return { items: formattedResult };
}
